import { createComponentProgrammatic } from '@/helpers/createComponentProgrammatic'
import { PassportsListModel as Model } from './Model'

export const MODULE_NAME = 'passports_list_routes'

export const PASSPORTS_LIST_ROUTES = {
  LAYOUT: MODULE_NAME,
  LIST: `${MODULE_NAME}.list`,
  VIEW: `${MODULE_NAME}.view`,
} as const

export const MENU = {
  id: PASSPORTS_LIST_ROUTES.LAYOUT,
  route: { name: PASSPORTS_LIST_ROUTES.LAYOUT },
  label: Model.page_title.list,
  icon: 'mdi-passport-plus',
} as const

export const createPassportRefreshModal = (parent: Vue, propsData: unknown) => {
  const AsyncComponent = import(
    /* webpackChunkName: "PassportRefreshModal" */
    './components/Modals/PassportRefreshModal.vue'
  )

  const result = createComponentProgrammatic(
    AsyncComponent,
    parent,
    propsData,
  )

  return result
}

export const createPassportReportModal = (parent: Vue, propsData: unknown) => {
  const AsyncComponent = import(
    /* webpackChunkName: "PublicationStorageModal" */
    './components/Modals/PassportReportModal.vue'
  )

  const result = createComponentProgrammatic(
    AsyncComponent,
    parent,
    propsData,
  )

  return result
}
